import { Link } from 'react-router-dom'

import usePageMeta from '../../utils/usePageMeta'
import './index.scss'

const NotFound = () => {
  usePageMeta({
    title: 'Page not found – Greg Chui',
    description: "The page you're looking for doesn't exist.",
    noindex: true,
  })

  return (
    <div className="container about-page not-found-page">
      <div className="text-zone">
        <h1>Page not found</h1>
        <p>Sorry, the page you're looking for doesn't exist.</p>
        <Link to="/" className="not-found-link">
          BACK TO HOME
        </Link>
      </div>
    </div>
  )
}

export default NotFound
